export default {"src":"/_next/static/media/mobil-logo.17c56813.svg","height":22,"width":104};